import { render, staticRenderFns } from "./EditBlock.vue?vue&type=template&id=d080bc20&scoped=true&"
import script from "./EditBlock.vue?vue&type=script&lang=js&"
export * from "./EditBlock.vue?vue&type=script&lang=js&"
import style0 from "./EditBlock.vue?vue&type=style&index=0&id=d080bc20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d080bc20",
  null
  
)

export default component.exports